import React from 'react';
import { SwiperComponent } from 'vitl-component-library';

// interfaces
import { IImage } from '../../interfaces/image';
// components
import AddToBasket from '../add-to-basket';

import Image from '@components/image/image';
// styles
import styles from './hero-health-product-with-carousel.module.scss';
//constants
import { OUT_OF_STOCK } from '@constants/messages';

interface IProps {
  title: string;
  heroTitleIcon?: any;
  subtitle: string;
  descriptions: string[];
  heroIconList?: Array<any>;
  images: IImage[];
  backgroundColor: string;
  loadingPlans: boolean;
  showFreeDeliveryText: boolean;
  plans: any;
  lazyload?: boolean;
  showDaysOffer?: boolean;
  isAvailable?: boolean;
}

const HeroHealthProductWithCarousel: React.FC<IProps> = ({
  title,
  heroTitleIcon,
  subtitle,
  descriptions,
  showDaysOffer,
  heroIconList,
  images,
  backgroundColor,
  loadingPlans,
  showFreeDeliveryText,
  plans,
  lazyload,
  isAvailable = true,
}: IProps) => {
  const slideComponent = (image: IImage, index: number) => {
    const imageSrc = image.filename_disk || image.icon_filename_disk || '';

    return (
      <div key={index} className={styles.item}>
        <Image filename={imageSrc} alt={image.title} width={300} />

        {image.title && <h4 className={styles.title}>{image.title}</h4>}

        {image.title && <hr className={backgroundColor === 'Primary' ? styles.hrLight : ''} />}

        {image.description && <div dangerouslySetInnerHTML={{ __html: image.description }} />}
      </div>
    );
  };

  return (
    <section
      className={styles.hero}
      style={{
        backgroundColor,
      }}
    >
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.image}>
            <SwiperComponent paginationType="bullets" spaceBetween={20} slidesPerView={1}>
              {images.map((image: IImage, index: number) => slideComponent(image, index))}
            </SwiperComponent>
          </div>
          <div className={styles.content}>
            <h1 className={styles.h1}>{title}</h1>

            {heroTitleIcon && <img src={`${process.env.GATSBY_MEDIA_URL}${heroTitleIcon.filename_disk}`} />}

            <p>
              <strong>{subtitle}</strong>
            </p>

            {descriptions.map(description => (
              <p>
                <strong dangerouslySetInnerHTML={{ __html: description }}></strong>
              </p>
            ))}

            {heroIconList && (
              <div className={styles.heroIconListWrapper}>
                {heroIconList.map(icon => (
                  <div className={styles.heroIconListItem}>
                    <img src={`${process.env.GATSBY_MEDIA_URL}${icon.filename_disk}`} width="26" />
                    <p>{icon.text}</p>
                  </div>
                ))}
              </div>
            )}

            <hr className={styles.hr} />
            {!loadingPlans && <AddToBasket daysOffer={showDaysOffer} plans={plans} isAvailable={isAvailable} />}
            {showFreeDeliveryText && <p className={styles.footnote}>Pause or cancel anytime</p>}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroHealthProductWithCarousel;
